// Lib
import { curry } from 'lodash/fp';

/**
 * Ensures a value lies within a range.
 */
export default curry((rangeStart, rangeMax, value) => Math.max(Math.min(value, rangeMax), rangeStart));
